import React, { useEffect } from 'react'

function InfoNotifications() {
    useEffect(() => {
        (async() => {

        })()
    }, [])

    return <div>
        InfoNotifications!
    </div>
}

export default InfoNotifications